export const COPY_TEXT = 'COPY_TEXT';
export const TEXT_COPIED = 'TEXT_COPIED';
export const COPY_BUTTON_HOVERED = 'COPY_BUTTON_HOVERED';
export const EDITOR_CHANGED = 'EDITOR_CHANGED';
export const RENDERURL_CHANGED = 'RENDERURL_CHANGED';
export const DIAGRAM_CHANGED = 'DIAGRAM_CHANGED';
export const DIAGRAM_CHANGED_UPDATE = 'DIAGRAM_CHANGED_UPDATE';
export const DIAGRAM_TYPE_CHANGED = 'DIAGRAM_TYPE_CHANGED';
export const OPEN_IMPORT_URL = 'OPEN_IMPORT_URL';
export const IMPORT_URL = 'IMPORT_URL';
export const CLOSE_IMPORT_URL = 'CLOSE_IMPORT_URL';
export const UPDATE_IMPORT_URL = 'UPDATE_IMPORT_URL';
export const DIAGRAM_HAS_ERROR = 'DIAGRAM_HAS_ERROR';
export const ZEN_MODE_CHANGED = 'ZEN_MODE_CHANGED';
export const KEY_PRESSED = 'KEY_PRESSED';
export const WINDOW_RESIZED = 'WINDOW_RESIZED';